<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { UITabPane, UITabs } from "@gohighlevel/ghl-ui";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import SidebarCustomFields from "./SidebarCustomFields.vue";
import SidebarStandardFields from "./SidebarStandardFields.vue";

const { t } = useI18n();

const store = useAppStore();

// Use computed properties for reactive translations
const quickAdd = computed(() => t("common.quickAdd"));
const customFields = computed(() => t("common.addObjectFields"));
</script>
<template>
  <div class="sidebar-elements-tabs">
    <UITabs justify-content="center" default-value="standard" type="segment">
      <UITabPane name="standard" :tab="quickAdd">
        <SidebarStandardFields />
      </UITabPane>
      <UITabPane name="custom" :tab="customFields">
        <SidebarCustomFields :custom-fields="store.getCustomFieldsFromStore" />
      </UITabPane>
    </UITabs>
  </div>
</template>

<style scoped>
.sidebar-elements-tabs :deep(.n-tabs .n-tabs-rail) {
  margin: 8px 12px 0;
  padding: 4px !important;
  gap: 2px;
  border-radius: 10px !important;
  background: #f2f4f7 !important;
}
.sidebar-elements-tabs :deep(.n-tabs .n-tabs-capsule) {
  border-radius: 8px !important;
  background: #ffffff !important;
  box-shadow: 0 1px 3px 0 rgba(16, 24, 40, 0.1), 0 1px 2px 0 rgba(16, 24, 40, 0.06) !important;
}
.sidebar-elements-tabs :deep(.n-tabs .n-tabs-tab) {
  border-radius: 8px !important;
  height: 32px;
  padding: 0 16px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  color: #667085 !important;
  transition: color 150ms ease-out;
}
.sidebar-elements-tabs :deep(.n-tabs .n-tabs-tab--active),
.sidebar-elements-tabs :deep(.n-tabs .n-tabs-tab.n-tabs-tab--active .n-tabs-tab__label) {
  color: #101828 !important;
}
</style>
